import { Injectable } from "@angular/core";
import { UtilsService } from "./utils.service";

@Injectable({
  providedIn: "root",
})
export class JobSiteService {
  public list: { id: number; name: string }[] = [];

  constructor(private _utilService: UtilsService) {}

  async getList() {
    if (this.list.length > 0) return this.list;

    return this._utilService.basic_get("/job-site").then((response: { id: number; name: string }[]) => {
      this.list = response;
      return response;
    });
  }
}
